import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Card from "../../card/Card";

import "./RequestForm.scss";


const RequestForm = ({
  request,
  requestImage,
  imagePreview,
  description,
  setDescription,
  handleInputChange,
  handleImageChange,
  saveRequest,
}) => {
  return (
    <div className="add-request">
      <Card cardClass={"card"}>
        <form onSubmit={saveRequest}>
          <Card cardClass={"group"}>
            <label>Requested Medicine Image</label>
            <code className="--color-dark">
              Supported Formats: jpg, jpeg, png
            </code>
            <input
              type="file"
              name="image"
              onChange={(e) => handleImageChange(e)}
            />

            {imagePreview != null ? (
              <div className="image-preview">
                <img src={imagePreview} alt="request" />
              </div>
            ) : (
              <p>No image set for this request.</p>
            )}
          </Card>
          <label>Requested Medicine Name:</label>
          <input
            type="text"
            placeholder="Requested medicine name"
            name="name"
            value={request?.name}
            onChange={handleInputChange}
          />

          <label>Requested Quantity:</label>
          <input
            type="text"
            placeholder="Requested Quantity"
            name="quantity"
            value={request?.quantity}
            onChange={handleInputChange}
          />

          <label>Additional Notes:</label>
          <ReactQuill
            theme="snow"
            value={description}
            onChange={setDescription}
            modules={RequestForm.modules}
            formats={RequestForm.formats}
          />

          <div className="--my">
            <button type="submit" className="--btn --btn-primary">
              Send Request
            </button>
          </div>
        </form>
      </Card>
    </div>
  );
};

RequestForm.modules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ align: [] }],
    [{ color: [] }, { background: [] }],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["clean"],
  ],
};
RequestForm.formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "color",
  "background",
  "list",
  "bullet",
  "indent",
  "link",
  "video",
  "image",
  "code-block",
  "align",
];

export default RequestForm;